'use client';

import './ProblemSolution.scss';

const ProblemSolution = () => {
  return (
    <section className='problem-solution'>
      <div className='container'>
        <div className='grid'>
          
          {/* The Old Way */}
          <div className='card old-way'>
            <div className='badge'>THE SILO PROBLEM</div>
            <div className='card-content'>
              <h3 className='card-title'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                  <polyline points="2 17 12 22 22 17"></polyline>
                  <polyline points="2 12 12 17 22 12"></polyline>
                </svg>
                Fragmented Operations
              </h3>
              <p className='card-description'>
                {`Security tools detect threats. IT tools fix systems. They don't talk to each other.
                You're stuck manually bridging the gap between your SIEM, EDR, and RMM, leading to slow response times and operational friction.`}
              </p>
              <ul className='feature-list'>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                  Separate tools for Security & IT
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                  Manual patching & configuration
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                  Automation requires complex scripts
                </li>
              </ul>
            </div>
          </div>

          {/* The Cylerian Way */}
          <div className='card cylerian-way'>
            <div className='badge highlight'>THE CYLERIAN ADVANTAGE</div>
            <div className='card-content'>
              <h3 className='card-title'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="18" cy="18" r="3"></circle>
                  <circle cx="6" cy="6" r="3"></circle>
                  <path d="M6 21V9a9 9 0 0 0 9 9"></path>
                </svg>
                Unified Ops Stack
              </h3>
              <p className='card-description'>
                {`One agent for Security and IT. Cylerian provides the "hands" to fix what it finds.
                Automate patching, software deployment, and threat remediation from a single control plane.`}
              </p>
              <ul className='feature-list'>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <strong>Security + IT</strong> in one agent
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <strong>Platform Native AI</strong> 
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <strong>Automated</strong> cross-domain workflows
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
